import * as types from '../mutation-types'

// state
export const state = {
  available_applepay: false
};

// getters
export const getters = {
  available_applepay: state => state.available_applepay
};

// mutations
export const mutations = {
  [types.AVAILABLE_APPLE_PAY](state, value) {
    state.available_applepay = value;
  }
};

// actions
export const actions = {
  availableApplePay({commit}, value) {
    commit(types.AVAILABLE_APPLE_PAY, value);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/options.js